// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver, ProductData } from '../../contexts'
import {
  ProductReviewsModuleContent,
  ProductReviewsModuleContentInput
} from './ProductReviews.contracts'
import { resolveProduct } from '../resolvers'
import { logger } from '../../support'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const resolveProductReviewModuleContent: ModuleContentResolver<ProductReviewsModuleContentInput, ProductReviewsModuleContent> =
  async (
    input: ProductReviewsModuleContentInput,
    relatedService: IRelatedService
  ): Promise<ProductReviewsModuleContent> => {
    let product: ProductData | null = null
    // todo: lirene: tu zniknelo resolvowanie reviewsow

    if (input.product) {
      try {
        product = await resolveProduct(input.product, relatedService)
      } catch (e) {
        logger(e, 'warn')
      }
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return {
      ...input,
      product
    }
  }

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const getPaginationConfig = (REVIEWS_AMOUNT = 50, REVIEWS_AMOUNT_PER_PAGE = 10) => {
  const totalPages = Math.ceil(REVIEWS_AMOUNT / REVIEWS_AMOUNT_PER_PAGE)
  const totalVisible = totalPages

  return {
    showDirectionButtons: false,
    totalPages,
    totalVisible
  }
}
